import * as React from 'react';
import { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { TravellerFieldEnum, useGetCheckinOrderQuery } from '@websky/graphql';
import { fillCheckinOrder } from '../../store/order/actions';
import OrderGuard from '../../../../OrderGuard/OrderGuard';
import Order from './Order/Order';
import { getCheckinOrder } from '../../store/order/selectors';
import CheckinErrorBoundary from './CheckinErrorBoundary/CheckinErrorBoundary';
import { useCheckinRestrictions, useUpdateCheckinTravellerServices } from '../../hooks';
import { getUserValue } from '../../../../utils';
const OrderWrapper = ({ orderId }) => {
    var _a, _b, _c;
    const dispatch = useDispatch();
    const order = useSelector(getCheckinOrder);
    const onOrderAccessGranted = useCallback(() => window.location.reload(), []);
    let lastName;
    let ticketNumber;
    if (order && order.travellers.length) {
        lastName = getUserValue(order.travellers[0], TravellerFieldEnum.LastName);
        ticketNumber = (_c = (_b = (_a = order.travellers[0]) === null || _a === void 0 ? void 0 : _a.tickets) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.number;
    }
    const orderLoaded = useMemo(() => {
        return !!order && order.id === orderId;
    }, [order, orderId]);
    const onOrderLoad = (order) => {
        dispatch(fillCheckinOrder(order));
    };
    useUpdateCheckinTravellerServices();
    useCheckinRestrictions();
    return (React.createElement(OrderGuard, { orderId: orderId, orderLoaded: orderLoaded, onOrderLoad: onOrderLoad, onOrderAccessGranted: onOrderAccessGranted, loadOrder: useGetCheckinOrderQuery },
        React.createElement(CheckinErrorBoundary, { lastName: lastName, ticketNumber: ticketNumber },
            React.createElement(Order, null))));
};
export default OrderWrapper;
